export function prettifyDate(dateString){
  return dateString.replace("T", " ");
}

export function removeTime(dateString) {
  return dateString.substring(0, 10);
}

export function formatDateToISO8601(unformattedDate) {
  if (unformattedDate instanceof Date) {
    unformattedDate = new Date(unformattedDate);
  }
  return formatDate(unformattedDate) + "T" + formatTime(unformattedDate);
}

export function formatDate(date = new Date()){
  if (date instanceof Date) {
    date = new Date(date);
  }

  let month = date.getMonth()+1;
  if((date.getMonth()+1) < 10) {
    month = "0"+month;
  }

  let day = date.getDate();
  if(date.getDate() < 10) {
    day = "0"+day;
  }

  let formattedDate = date.getFullYear() + '-' + (month) + '-' + day;
  return formattedDate;
}

export function formatTime(date = new Date()){
  if (date instanceof Date) {
    date = new Date(date);
  }

  let hours = date.getHours();
  if((date.getHours() < 10) ) {
    hours = "0"+hours;
  }

  let minutes = date.getMinutes();
  if((date.getMinutes() < 10) ) {
    minutes = "0"+minutes;
  }

  let seconds = date.getSeconds();
  if((date.getSeconds() < 10) ) {
    seconds = "0"+seconds;
  }

  return hours +':'+ minutes +':'+ seconds;
}

export function formatTransactionCardDate(time, now = new Date(Date.now())) {

  let d = new Date(time);

  let transactionDate = {
    "yyyy": d.getFullYear(),
    "mm": (d.getMonth() + 1).toString().length === 2 ? (d.getMonth() + 1) : "0" + (d.getMonth() + 1),
    "dd": d.getDate(),
    "hh": d.getHours(),
    "m": d.getMinutes(),
    "date": (d.getFullYear()) + "-" + ((d.getMonth() + 1).toString().length === 2 ? (d.getMonth() + 1) : "0" + (d.getMonth() + 1)) + "-" + (d.getDate().toString().length === 2 ? d.getDate() : "0" + d.getDate())
  };

  let todayDate = {
    "yyyy": now.getFullYear(),
    "mm": (now.getMonth() + 1).toString().length === 2 ? (now.getMonth() + 1) : "0" + (now.getMonth() + 1),
    "dd": now.getDate(),
    "hh": now.getHours(),
    "m": now.getMinutes()
  };

  let dateDifference = {
    "yyyy": todayDate["yyyy"] - transactionDate["yyyy"],
    "mm": todayDate["mm"] - transactionDate["mm"],
    "dd": todayDate["dd"] - transactionDate["dd"],
    "hh": todayDate["hh"] - transactionDate["hh"],
    "m": todayDate["m"] - transactionDate["m"]
  };

  if (dateDifference["yyyy"] !== 0) {
    return transactionDate["date"];
  } else {
    if (dateDifference["mm"] !== 0) {
      return transactionDate["date"];
    } else {
      if (dateDifference["dd"] === 1) {
        return "Yesterday";
      } else if (dateDifference["dd"] !== 0) {
        return transactionDate["date"];
      } else {
        if (dateDifference["hh"] !== 0) {
          if (dateDifference["hh"] === 1) {
            return dateDifference["hh"] + " hour ago";
          } else {
            return dateDifference["hh"] + " hours ago";
          }
        } else {
          if (dateDifference["m"] !== 0) {
            if (dateDifference["m"] === 1) {
              return dateDifference["m"] + " minute ago";
            } else {
              return dateDifference["m"] + " minutes ago";
            }
          } else {
            return "Just now";
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/DateFormatter.js